<template>
  <div class="articlerank">
    <sub-title :text="title" />
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index" @click="tojump(item)">
        <div class="title">
          {{ item.title | toEllipsisFilter(spl) }}
        </div>
        <div class="between">
          <div class="name center">
            <img :src="item.avatar" alt="" />
            {{ item.true_name }}
          </div>
          <div class="num center">
            <img src="~assets/base/kan.png" alt="" />
            {{ item.view_num }}人看过
          </div>
        </div>
      </div>
    </div>
    <div class="in_batch" @click="Inabatch">换一批</div>
  </div>
</template>

<script>
import subTitle from "../../home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  props: {
    list: Array,
    title: String,
    num: Number,
    spl: {
      type: Number,
      default: 15,
    },
  },
  methods: {
    Inabatch() {
      this.$emit("Inabatch");
    },
    tojump(item) {
      this.$router.push({
        path: "/laws/articimdet",
        query: {
          articinId: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.articlerank {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  padding: 24px 20px;
  .list {
    margin-top: 32px;
    .item {
      margin-top: 27px;
      cursor: pointer;
      .title {
        font-size: 16px;
        line-height: 16px;
        color: #333333;
        margin-bottom: 12px;
      }
      .name {
        font-size: 14px;
        color: #666666;
        img {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          margin-right: 6px;
        }
      }
      .num {
        font-size: 12px;
        color: #999999;
        img {
          width: 15px;
          height: 12px;
          margin-right: 10px;
        }
      }
      &:hover {
        .title {
          color: #0465ea;
        }
      }
    }
  }
  .in_batch {
    text-align: center;
    width: 120px;
    height: 36px;
    line-height: 36px;
    border: 1px solid #0465ea;
    border-radius: 2px;
    font-size: 16px;
    color: #0465ea;
    margin: 30px auto 0;
    cursor: pointer;
  }
}
</style>